module.exports = __webpack_public_path__ + "img/logoWithoutText.c1a82235.png";